let timerTimeout;
let serialNo = "";
let modelNo = "";
let noOfApiCalls = 0;
window.api_config = window.api_config || {};
window.api_config.API_ENDPOINTS = window.api_config.API_ENDPOINTS || {};
window.api_config.API_ENDPOINTS.otpFetch = 'https://orient.marmeto.com/api/anonymous/otp';
window.api_config.API_ENDPOINTS.otpVerification = 'https://orient.marmeto.com/api/anonymous/verify';
// window.api_config.API_ENDPOINTS.CRM_API = 'https://2f0a5db6c1d8.ngrok.app';
window.api_config.API_ENDPOINTS.CRM_API = 'https://brand.orientelectric.com';
// window.api_config.API_ENDPOINTS.CRM_API = 'https://946c-106-51-68-87.ngrok-free.app';
const phoneVerification = document.querySelector(".phone-verification");
const productDetails = document.querySelector(".product-registration-container");
const serialQR = document.querySelector(".serial-qr-container");
const registerButton = document.querySelector(".register-button");

const serialNoSubmit = document.querySelector("#sr-no-submit");
const verifyButton = document.querySelector(".verify-button");
const otpInputs = document.querySelector(".opt-varification");
const otpSubmitButton = document.querySelector(".submit-otp");
const uploadDetails = document.querySelector(".upload-details");
const scanQrButton = document.querySelector(".scan-qr");
const qrSerialInfo = document.querySelector(".info-help");
const closeButton = document.querySelector(".qr-serial-info-container .close-button");

const registrationDetailsSubmit = document.querySelector("#registration-details-submit");
const registrationSucess = document.querySelector(".registration-sucess-slide");

document.querySelector(".upload-details #purchase_date").addEventListener("paste", (event) => {
  event.preventDefault();
});
document.querySelector(".upload-details #purchase_date").addEventListener("copy", (event) => {
  event.preventDefault();
});
document.querySelector(".upload-details #purchase_date").addEventListener("cut", (event) => {
  event.preventDefault();
});


closeButton.addEventListener("click", () => {
  document.querySelector("body").style.overflow = "unset";
  document.querySelector(".qr-serial-info").classList.add("hidden");
});

qrSerialInfo.addEventListener("click", () => {
  document.querySelector("body").style.overflow = "hidden";
  document.querySelector(".qr-serial-info").classList.remove("hidden");
});

registerButton?.addEventListener("click", () => {
  phoneVerification?.classList.remove("hidden");
  updateProgress(2);
  productDetails?.classList.add("hidden");
  focusToSection();
});

document.querySelector(".upload-details #customer-name").addEventListener("input", (e) => {
  let value = e.target.value;

  // Remove any numeric and special characters
  value = value.replace(/[^a-zA-Z\s]/g, '');

  // Limit the length to 25 characters
  if (value.length > 25) {
    value = value.slice(0, 25);
  }

  // Update the input value
  e.target.value = value;
})

document.querySelector("#serial-number").addEventListener("input", (e) => {
  let value = e.target.value;

  // Remove any special characters
  value = value.replace(/[^a-zA-Z0-9]/g, '');

  // Convert to uppercase
  value = value.toUpperCase();

  // Limit the length to 18 characters
  if (value.length > 18) {
    value = value.slice(0, 18);
  }

  // Update the input value
  e.target.value = value;
});

document.querySelectorAll("#otp1, #otp2, #otp3, #otp4").forEach((input, index, inputs) => {
  input.addEventListener("paste", (event) => {
    event.preventDefault(); // Prevent default paste behavior

    const pastedData = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 4); // Get only digits (max 4)
    
    if (pastedData.length === 4) {
      // Populate OTP fields
      inputs.forEach((field, i) => {
        field.value = pastedData[i] || ""; // Assign each digit
      });

      // Focus the last non-empty field
      inputs[Math.min(3, pastedData.length - 1)].focus();
    }
  });
});


document.querySelector(".phone-verification .edit-btn").addEventListener("click", () => {
  otpInputs.classList.add("hidden");
  verifyButton?.classList.remove("hidden");
  document.querySelector("#otp-mobile-number").removeAttribute("disabled");
  document.querySelector("#otp-mobile-number").focus();
  document.getElementById("otp1").value = "";
  document.getElementById("otp2").value = "";
  document.getElementById("otp3").value = "";
  document.getElementById("otp4").value = "";
});

verifyButton?.addEventListener("click", otpFetch);

document.querySelector(".resend-otp-button").addEventListener("click", otpFetch);

function otpFetch() {
  let mobileNumber = document.querySelector("#otp-mobile-number").value;
  const mobileRegex = /^(?!0000000000)\d{10}$/;
  if (mobileNumber.length == 0 || !mobileRegex.test(mobileNumber)) {
    document.querySelector("#phone-number-error").textContent = "Enter a valid 10-digit mobile number.";
    document.querySelector("#phone-number-error").classList.remove("hidden");
    return;
  }

  if (!document.querySelector("#phone-number-error").classList.contains("hidden")) {
    document.querySelector("#phone-number-error").classList.add("hidden");
  }

  // Show loader
  document.querySelector(".loader-container").classList.remove("hidden");

  let phoneNumber = document.querySelector("#otp-mobile-number").value;
  let payload = {
    phoneNumber: phoneNumber,
  };

  fetch(window.api_config.API_ENDPOINTS.otpFetch, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      // Hide loader
      document.querySelector(".loader-container").classList.add("hidden");

      if (data.status == "FAILURE") {
        console.log(data.status)
        let errorMessage = data.message && data.message.includes('Multiple') 
          ? data.message 
          : "Something went wrong. Please try after sometime.";
        console.log(errorMessage)
        document.querySelector("#phone-number-error").innerText = errorMessage;
        document.querySelector("#phone-number-error").classList.remove("hidden");
      } else {
        document.querySelector(".verified-no").textContent = phoneNumber;
        document.querySelector("#otp-mobile-number").setAttribute("disabled", true);
        otpInputs?.classList.remove("hidden");
        verifyButton?.classList.add("hidden");
        otpTimeout();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      // Hide loader
      document.querySelector(".loader-container").classList.add("hidden");
      document.querySelector(".api-error-message").innerText = "Something went wrong. Please try later.";
      document.querySelector(".api-error").classList.remove("hidden");
    });
}

function otpTimeout(){
  let time = 60;
  clearInterval(timerTimeout);
  document.querySelector(".resend-timer").classList.remove("hidden");
  document.querySelector(".resend-otp-button").classList.add("hidden");
  timerTimeout = setInterval(() => {
    if (time <= 1) {
      clearInterval(timerTimeout);
      document.querySelector(".resend-timer").classList.add("hidden");
      document.querySelector(".resend-otp-button").classList.remove("hidden");
      document.querySelector(".resend-timer span").textContent = '60';
      return;
    }
    document.querySelector(".resend-timer span").textContent = time;
    time = time - 1;
  }, 1000);
}



let phoneNumber = "";

otpSubmitButton.addEventListener("click", (e) => {
  e.preventDefault();

  // Get the mobile number and OTP input values
  let cfMobileNumber = document.getElementById("otp-mobile-number").value;
  phoneNumber = cfMobileNumber;
  let otpInput1 = document.getElementById("otp1").value;
  let otpInput2 = document.getElementById("otp2").value;
  let otpInput3 = document.getElementById("otp3").value;
  let otpInput4 = document.getElementById("otp4").value;
  let otp = otpInput1 + otpInput2 + otpInput3 + otpInput4;

  if (otp.length !== 4) {
    document.querySelector(".complaint-invalid-OTP").style.display = "block";
    document
      .getElementById("complaint-OTP-submit-button")
      .setAttribute("disabled", true);
    return;
  }

  document.getElementById("otp-mobile-number").setAttribute("disabled", true);

  let payload = {
    phoneNumber: cfMobileNumber,
    otp: otp,
  };

  // Make the POST request to verify the OTP
  fetch(window.api_config.API_ENDPOINTS.otpVerification, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then((data) => {
      sessionStorage.removeItem("complaintVerificationToken");
      if (data.status === "OTP_INVALID" || data.status === "FAILURE") {
        document.querySelector("#otp-invalid-error").classList.remove("hidden");
      } else {
        // ✅ STORE verificationToken in sessionStorage
        if (data.verificationToken) {
          sessionStorage.setItem("complaintVerificationToken", data.verificationToken);
        }
        
        uploadDetails?.classList.remove("hidden");
        updateProgress(3);
        phoneVerification?.classList.add("hidden");
        document.querySelector(".submit-phone-number").value = phoneNumber;
        document.querySelector(".submit-serial-number").value = serialNo;
        document.getElementById("otp1").value = "";
        document.getElementById("otp2").value = "";
        document.getElementById("otp3").value = "";
        document.getElementById("otp4").value = "";

        const pincode = document.querySelector(".upload-details #customer-pincode");

        const savedPincode = localStorage.getItem('user_pincode');
        if(savedPincode && pincode){
          pincode.value = savedPincode;
        }
      }
    })
    .catch((error) => {
      document.querySelector("#otp-invalid-error").classList.remove("hidden");
      document
        .getElementById("complaint-OTP-submit-button")
        .removeAttribute("disabled");
    });
});

scanQrButton?.addEventListener("click", () => {
  if (document.querySelector("#html5-qrcode-button-camera-start")) {
    document.querySelector("#html5-qrcode-button-camera-start").click();
  }
  focusToQR();
});

document.querySelector("#otp-mobile-number").
addEventListener("input", (event) => {
  let value = event.target.value;

  // Remove non-numeric characters (including 'e' and alphabetic characters)
  value = value.replace(/\D/g, ''); 

  // If the phone number exceeds 10 digits, trim it
  if (value.length > 10) {
    value = value.slice(0, 10);
  }

  // Update the input value
  event.target.value = value;
});



const inputs = document.querySelectorAll(".otp-input");
inputs.forEach((input, index) => {
  input.addEventListener("input", (event) => {
    let value = event.target.value;

    // Allow only digits (0-9)
    value = value.replace(/\D/g, ''); // Remove anything that's not a digit (including '-')

    // If the value is more than 1 character, prevent it and keep only the first digit
    if (value.length > 1) {
      event.preventDefault();
      value = value[0]; // Keep only the first digit
    }

    // Update the input value
    event.target.value = value;

    // If it's a valid digit and we're not at the last input, move to the next input
    if (value.length === 1 && index < inputs.length - 1) {
      inputs[index + 1].focus();
    }
  });


  // Handle Backspace to move to the previous input
  input.addEventListener("keydown", (event) => {
    if (event.key === "Backspace" && !input.value && index > 0) {
      inputs[index - 1].focus();
    }
  });

  // Handle Paste Event
  input.addEventListener("paste", (event) => {
    const pasteData = event.clipboardData.getData("text");
    if (/^\d{4}$/.test(pasteData)) {
      pasteData.split("").forEach((digit, idx) => {
        if (inputs[idx]) {
          inputs[idx].value = digit;
        }
      });
      inputs[inputs.length - 1].focus();
    }
    event.preventDefault();
  });
});

document.querySelector(".upload-details #terms-nd-condition").addEventListener("change", (e) => {
  if (e.target.checked) {
    registrationDetailsSubmit.classList.remove("disabled");
  } else {
    registrationDetailsSubmit.classList.add("disabled");
  }
})

function focusToSection() {
  setTimeout(() => {
    const container = document.querySelector(".warranty-registration");

    if (container) {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const offsetTop = container.getBoundingClientRect().top + window.scrollY;
      
      window.scrollTo({
        top: offsetTop - (isMobile ? 50 : 200), // Adjust for mobile
        behavior: "smooth",
      });
    }
  }, 300);
}

function focusToQR() {
  setTimeout(() => {
    const container = document.querySelector(".warranty-registration");

    if (container) {
      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      const offsetTop = container.getBoundingClientRect().top + window.scrollY;
      
      window.scrollTo({
        top: offsetTop - (isMobile ? 50 : 200) + 450, // Adjust for mobile
        behavior: "smooth",
      });
    }
  }, 300);
}


function onScanSuccess(decodeText, decodeResult) {
  document.querySelector("#close-qr-scanner").classList.add("hidden");
  if(decodeText.includes('https://tcbp.orientelectric.com/')){
    const parts = decodeText.split('?');
    decodeText = parts.length > 1 ? parts[1] : "";
  }
  window.htmlscanner.stop().then(() => {
    productDetailsView(decodeText);
  });
}

serialNoSubmit.addEventListener("click", (e) => {
  noOfApiCalls = 0;
  serialNo = document.querySelector("#serial-number").value
  if (document.querySelector("#serial-number").value) {
    productDetailsView(document.querySelector("#serial-number").value);
  } else {
    document.querySelector("#serial-number-error").classList.remove("hidden");
  }
});

async function productDetailsView(serial) {
  document.querySelector(".loader-container").classList.remove("hidden");
  serialNo = serial;
  let url = window.api_config.API_ENDPOINTS.CRM_API + "/api/product/getProductData";
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ object_id: serial }),
  };
  try {
    const response = await fetch(url, config);
    const data = await response.json();
    if(data.success){
      updateProgress(1);
      document.querySelector(".loader-container").classList.add("hidden");
    showProductDetailsSlide(serial, data.data.extractedData[0]);
    }else{
      if (data.status > 200 && data.status <= 400) {
        if (noOfApiCalls < 1) {
          noOfApiCalls++;
          console.log(`Retrying... attempt ${noOfApiCalls}`);
          productDetailsView(serial);
          return;
        }
        let errorMessage = "Something went wrong. Please try later.";
        if(data?.message === "Server: Iot data not found"){
            errorMessage = "Data not found"
        }
        
        document.querySelector(".api-error-message").innerText = errorMessage;
      } else if (data.status > 400 && data.status <= 500) {
          document.querySelector(".api-error-message").innerText = "Bad request.";
      }
      document.querySelector(".api-error").classList.remove("hidden");
      document.querySelector(".loader-warranty").classList.add("hidden");
    }
  } catch (err) {
    console.log(err);
    if (noOfApiCalls < 1) {
      noOfApiCalls++;
      console.log(`Retrying after network error... attempt ${noOfApiCalls}`);
      productDetailsView(serial);
      return;
    }
    document.querySelector(".api-error").classList.remove("hidden");
    document.querySelector(".loader-warranty").classList.add("hidden");
  }
}

document.querySelector(".api-error-button").addEventListener("click", () => {
  location.reload();
  document.querySelector(".api-error").classList.add("hidden");
  document.querySelector(".loader-container").classList.add("hidden");
  document.querySelector(".loader-warranty").classList.remove("hidden");
})


function showProductDetailsSlide(serial, data) {
    document.querySelector(`.product-name-value`).textContent = data.title;
    document.querySelector(`.product-category-value`).textContent = data.title;
    let quantityElem = document.querySelector(`.product-quantity`);
    let materialCodeElem = document.querySelector(`.product-material-code`);
    let serialNumberElem = document.querySelector(".product-serial-number");
    let stage = data?.stage?.trim()
    let allowRegistration = !stage || (stage == "L0" || stage == "L1");

    let registrationButton = document.querySelector(".registeration-button-container");
    let progressBar = document.querySelector(".progress-bar");
    let formImageContainer = document.querySelector(".form-image-container");
    let registrationBenefits = document.querySelector(".registration-benefits");

  if (!allowRegistration) {
    quantityElem.querySelector(".product-quantity-value").textContent = data.quantity;
    quantityElem.classList.remove("hidden");
    materialCodeElem.querySelector(".product-material-code-value").textContent = data.materialCode;
    materialCodeElem.classList.remove("hidden");
    serialNumberElem.querySelector(".product-serial-number-value").textContent = data.materialCode;
    serialNumberElem.classList.remove("hidden");
    progressBar.classList.add("hidden");
    formImageContainer.classList.add("hidden");
    registrationBenefits.classList.add("hidden");
  } else {
    registrationButton.classList.remove("hidden");
    registrationButton.querySelector("button").removeAttribute("disabled");
  }



  productDetails.querySelector(".serial-no-input").value = serial;
  modelNo = data.materialCode;
  productDetails?.classList.remove("hidden");
  serialQR?.classList.add("hidden");
  focusToSection();
}

document.querySelector(".qr-nd-text").addEventListener("click", (e) => {
  e.preventDefault();
  if (!window.htmlscanner) {
    window.htmlscanner = new Html5Qrcode("my-qr-reader");
    window.htmlscanner
      .start(
        { facingMode: "environment" },
        {
          fps: 60,
          showTorchButtonIfSupported: true,
        },
        onScanSuccess
      )
      .then(() => {
        document.querySelector("#close-qr-scanner").classList.remove("hidden");
      });
  }
  document.querySelector(".qr-nd-text").style.display = "none";
});

document.querySelector("#close-qr-scanner").addEventListener("click", (e) => {
  window.htmlscanner.stop();
  window.htmlscanner = null;
  document.querySelector("#close-qr-scanner").classList.add("hidden");
  document.querySelector(".qr-nd-text").style.display = "flex";
});

registrationDetailsSubmit.addEventListener("click", function (e) {
    e.preventDefault(); // Prevent default button behavior
    if (!document.getElementById("terms-nd-condition").checked) {
      return;
    }
    document.querySelector(".loader-container").classList.remove("hidden");
    const databank = document.querySelector("#meta-data-config");
    const hash = databank.dataset.hash;
    const timestamp = databank.dataset.timestamp;
    const shop = databank.dataset.shop;

    const name = document.querySelector(".upload-details #customer-name").value;
    const email = document.querySelector(".upload-details #customer-email").value;
    let purchase_date = document.querySelector(".upload-details #purchase_date").value;
    const pincode = document.querySelector(".upload-details #customer-pincode").value;
    const marketing = document.querySelector("#marketing").value;
    const fileInput = document.getElementById("file-input").files[0]; // Get the uploaded file
    const dealerCode = document.querySelector(".upload-details #dealer-code").value;

    if (!name) {
      document.querySelector(".name-error").classList.remove("hidden");
      document.querySelector(".loader-container").classList.add("hidden");
      return;
    } else {
      document.querySelector(".name-error").classList.add("hidden");
    }   

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!email || !emailPattern.test(email)) {
        document.querySelector(".email-error").classList.remove("hidden");
        document.querySelector(".loader-container").classList.add("hidden");
        return;
      }else {
        document.querySelector(".email-error").classList.add("hidden");
      }   

    const pincodePattern = /^[1-9]{1}[0-9]{5}$/;

    if (!pincode || !pincodePattern.test(pincode)) {
      document.querySelector(".user_pincode_error").classList.remove("hidden");
      document.querySelector(".loader-container").classList.add("hidden");
      return;
    } else {
      document.querySelector(".user_pincode_error").classList.add("hidden");
    }

    if (!purchase_date) {
        document.querySelector(".purchase_date-error").classList.remove("hidden");
        document.querySelector(".loader-container").classList.add("hidden");
        return;
      } else {
        document.querySelector(".purchase_date-error").classList.add("hidden");
      }  

    if (!fileInput) {
      document.querySelector(".loader-container").classList.add("hidden");
      document.querySelector('.upload-invoice').innerText = "Please uploade the invoice file."
      document.querySelector('.upload-invoice').style.color = "red"
      return;
    }  

    // Create FormData object to handle file upload
    const formData = new FormData();
    formData.append("productSerialNumber", serialNo);
    formData.append("modelCode", modelNo);
    formData.append("mobileNumber", phoneNumber);
    formData.append("customerName", name);
    formData.append("email", email);
    formData.append("purchase_date", purchase_date);
    formData.append("marketing_enable", marketing)
    formData.append("store", shop);
    formData.append("customerPincode", pincode);
    formData.append("dealerName", dealerCode);

    if (fileInput) {
      formData.append("invoiceCopy", fileInput);
    }

  console.groupCollapsed("FormData Contents");
for (const [key, value] of formData.entries()) {
  if (value instanceof File) {
    console.log(`${key}:`, {
      name: value.name,
      type: value.type,
      size: `${(value.size / 1024).toFixed(2)} KB`,
      lastModified: new Date(value.lastModified)
    });
  } else {
    console.log(`${key}:`, value);
  }
}
console.groupEnd();

   const endpoint = window.api_config.API_ENDPOINTS.CRM_API + "/api/register/user";
  console.log("Sending request to:", endpoint);

    // Make a POST request using fetch
    fetch(window.api_config.API_ENDPOINTS.CRM_API  + "/api/register/user", {
      method: "POST",
      headers: {
        "Hash": hash,
        "Timestamp": timestamp,
        "X-Origin": shop,
        "Authorization": `Bearer ${sessionStorage.getItem("complaintVerificationToken")}`
      },
      body: formData,
    })
      .then((response) => response.json())  
      .then((data) => {
        if (data.success) {
        document.querySelector(".loader-container").classList.add("hidden");
        updateProgress(4);
        registrationSucess?.classList.remove("hidden");
        uploadDetails?.classList.add("hidden");
        let time = 15;
        clearInterval(timerTimeout);
        timerTimeout = setInterval(() => {
          if (time <= 0) {
            window.location.href = "/";
            clearInterval(timerTimeout);
            return;
          }
          document.querySelector(".redirection-timer").textContent = time;
          time = time - 1;
      }, 1000);
      focusToSection();
        } else {
          document.querySelector(".api-error").classList.remove("hidden");
          document.querySelector(".loader-warranty").classList.add("hidden");
        }
      })
      .catch((error) => {
        console.log("Error", error)
        document.querySelector(".api-error-message").innerText = "Something went wrong. Please try later.";
        document.querySelector(".api-error").classList.remove("hidden");
        document.querySelector(".loader-warranty").classList.add("hidden");
      });
  });

  document.getElementById('file-input').addEventListener('change', function(event) {
    const fileInput = event.target;
    const fileNameDisplay = document.querySelector('.file-name');
    const fileNameSpan = fileNameDisplay.querySelector('span');
    const uploadInvoiceDiv = document.querySelector('.upload-invoice');

    // Reset UI state
    uploadInvoiceDiv.style.color = '';
    
    if (fileInput.files.length > 0) {
        const file = fileInput.files[0];
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic'];
        const maxSize = 4 * 1024 * 1024; // 4MB

        console.log(`📂 Selected File: ${file.name}, Size: ${(file.size / 1024).toFixed(2)} KB`);

        // Validate type
        if (!allowedTypes.includes(file.type)) {
            alert('Unsupported file type. Please use PDF, JPEG, PNG, or HEIC.');
            fileInput.value = '';
            return;
        }

        // Validate size
        if (file.size > maxSize) {
            alert(`File size exceeds ${(maxSize / (1024 * 1024))}MB limit.`);
            fileInput.value = '';
            return;
        }

        // Update UI
        fileNameDisplay.classList.remove('hidden');
        fileNameSpan.textContent = file.name;
        uploadInvoiceDiv.textContent = 'Uploaded';
        uploadInvoiceDiv.style.color = 'green';
    }
});


/**
 * Compress PDFs (removes unnecessary data)
 */
async function compressPDF(file) {
    const pdfBytes = await file.arrayBuffer();
    
    // Using PDF-Lib for compression (optional)
    const pdfDoc = await PDFLib.PDFDocument.load(pdfBytes);
    const compressedPdfBytes = await pdfDoc.save({ useObjectStreams: false });

    return new File([compressedPdfBytes], file.name, { type: "application/pdf" });
}


function updateProgress(currentStep) {
  const totalSteps = 4; // Total number of steps
  const progressLine = document.querySelector(".progress-line");
  const milestones = document.querySelectorAll(".milestone");
  const Pgbar = document.querySelectorAll(".progress-bar");
  
  // Calculate progress percentage
  let progressPercent = (currentStep / (totalSteps - 1)) * 100;
  if(progressPercent > 100){
    progressPercent = 100;
  }
  // Update progress line width
  progressLine.style.width = `${progressPercent}%`;

  // Update milestones (dots and labels)
  milestones.forEach((milestone) => {
    const step = parseInt(milestone.getAttribute("data-step"));
    if (step <= currentStep) {
      milestone.querySelector(".dot").classList.add("completed");
      milestone.querySelector(".label").classList.add("completed");
    } else {
      milestone.querySelector(".dot").classList.remove("completed");
      milestone.querySelector(".label").classList.remove("completed");
    }
  });

   Pgbar.forEach((bar) => {
          if (progressPercent > 0) {
            bar.classList.remove("hidden");
          } else {
            bar.classList.add("hidden");
          }
        });
}


